function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.586 8L4.293 2.707a1 1 0 011.414-1.414l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L9.586 8z"
});

function SvgChevronBigRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNTg1NzkgOEw0LjI5Mjg5IDIuNzA3MTFDMy45MDIzNyAyLjMxNjU4IDMuOTAyMzcgMS42ODM0MiA0LjI5Mjg5IDEuMjkyODlDNC42ODM0MiAwLjkwMjM2OSA1LjMxNjU4IDAuOTAyMzY5IDUuNzA3MTEgMS4yOTI4OUwxMS43MDcxIDcuMjkyODlDMTIuMDk3NiA3LjY4MzQyIDEyLjA5NzYgOC4zMTY1OCAxMS43MDcxIDguNzA3MTFMNS43MDcxMSAxNC43MDcxQzUuMzE2NTggMTUuMDk3NiA0LjY4MzQyIDE1LjA5NzYgNC4yOTI4OSAxNC43MDcxQzMuOTAyMzcgMTQuMzE2NiAzLjkwMjM3IDEzLjY4MzQgNC4yOTI4OSAxMy4yOTI5TDkuNTg1NzkgOFoiLz4KPC9zdmc+Cg==";
export { SvgChevronBigRight16 as ReactComponent };